"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectInfoBoxTab = void 0;
const bridge_1 = require("@completeanatomy/bridge");
const InfoBoxStateProvider_1 = require("../providers/InfoBoxStateProvider");
const react_1 = require("react");
const useAvailableTabs_1 = require("./useAvailableTabs");
const useInfoBoxStateReducer_1 = require("./useInfoBoxStateReducer");
function useSelectInfoBoxTab(type) {
    const [{ currentTab }, dispatch] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const availableTabs = (0, useAvailableTabs_1.useAvailableTabs)();
    const bridge = (0, bridge_1.useBridge)();
    (0, react_1.useEffect)(() => {
        if (currentTab !== type && availableTabs.includes(type)) {
            dispatch((0, useInfoBoxStateReducer_1.selectTab)(type));
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(type);
        }
    }, [currentTab, bridge, dispatch, type, availableTabs]);
}
exports.useSelectInfoBoxTab = useSelectInfoBoxTab;
